export const MedicineList = [
  { id: 1, name: "Paracetamol", form: "Tablet", strength: "500mg" },
  { id: 2, name: "Ibuprofen", form: "Tablet", strength: "400mg" },
  { id: 3, name: "Amoxicillin", form: "Capsule", strength: "250mg" },
  { id: 4, name: "Ciprofloxacin", form: "Tablet", strength: "500mg" },
  { id: 5, name: "Metformin", form: "Tablet", strength: "850mg" },
  { id: 6, name: "Amlodipine", form: "Tablet", strength: "5mg" },
  { id: 7, name: "Atorvastatin", form: "Tablet", strength: "20mg" },
  { id: 8, name: "Omeprazole", form: "Capsule", strength: "20mg" },
  { id: 9, name: "Levothyroxine", form: "Tablet", strength: "50mcg" },
  { id: 10, name: "Lisinopril", form: "Tablet", strength: "10mg" },
    { id: 11, name: "Simvastatin", form: "Tablet", strength: "40mg" },
    { id: 12, name: "Gabapentin", form: "Capsule", strength: "300mg" },
    { id: 13, name: "Furosemide", form: "Tablet", strength: "40mg" },
    { id: 14, name: "Hydrochlorothiazide", form: "Tablet", strength: "25mg" },
    { id: 15, name: "Prednisone", form: "Tablet", strength: "10mg" },
        { id: 16, name: "Azithromycin", form: "Tablet", strength: "500mg" },
        { id: 17, name: "Cetirizine", form: "Tablet", strength: "10mg" },
        { id: 18, name: "Doxycycline", form: "Capsule", strength: "100mg" },
        { id: 19, name: "Pantoprazole", form: "Tablet", strength: "40mg" },
        { id: 20, name: "Ranitidine", form: "Tablet", strength: "150mg" },
        { id: 21, name: "Metronidazole", form: "Tablet", strength: "400mg" },
        { id: 22, name: "Diclofenac", form: "Tablet", strength: "50mg" },
        { id: 23, name: "Losartan", form: "Tablet", strength: "50mg" },
        { id: 24, name: "Clopidogrel", form: "Tablet", strength: "75mg" },
        { id: 25, name: "Aspirin", form: "Tablet", strength: "75mg" },
        { id: 26, name: "Montelukast", form: "Tablet", strength: "10mg" },
        { id: 27, name: "Salbutamol", form: "Tablet", strength: "4mg" },
        { id: 28, name: "Spironolactone", form: "Tablet", strength: "25mg" },
        { id: 29, name: "Glibenclamide", form: "Tablet", strength: "5mg" },
        { id: 30, name: "Gliclazide", form: "Tablet", strength: "80mg" },
        { id: 31, name: "Enalapril", form: "Tablet", strength: "5mg" },
        { id: 32, name: "Ramipril", form: "Tablet", strength: "5mg" },
        { id: 33, name: "Telmisartan", form: "Tablet", strength: "40mg" },
        { id: 34, name: "Atenolol", form: "Tablet", strength: "50mg" },
        { id: 35, name: "Propranolol", form: "Tablet", strength: "40mg" },
        { id: 36, name: "Bisoprolol", form: "Tablet", strength: "5mg" },
        { id: 37, name: "Carvedilol", form: "Tablet", strength: "6.25mg" },
        { id: 38, name: "Metoprolol", form: "Tablet", strength: "50mg" },
        { id: 39, name: "Nifedipine", form: "Tablet", strength: "10mg" },
        { id: 40, name: "Verapamil", form: "Tablet", strength: "40mg" },
        { id: 41, name: "Diltiazem", form: "Tablet", strength: "30mg" },
        { id: 42, name: "Aspirin", form: "Tablet", strength: "325mg" },
        { id: 43, name: "Warfarin", form: "Tablet", strength: "5mg" },
        { id: 44, name: "Heparin", form: "Injection", strength: "5000IU" },
        { id: 45, name: "Insulin", form: "Injection", strength: "100IU/ml" },
        { id: 46, name: "Glimepiride", form: "Tablet", strength: "2mg" },
        { id: 47, name: "Pioglitazone", form: "Tablet", strength: "15mg" },
        { id: 48, name: "Sitagliptin", form: "Tablet", strength: "100mg" },
        { id: 49, name: "Vildagliptin", form: "Tablet", strength: "50mg" },
        { id: 50, name: "Linagliptin", form: "Tablet", strength: "5mg" },
        { id: 51, name: "Dapagliflozin", form: "Tablet", strength: "10mg" },
        { id: 52, name: "Empagliflozin", form: "Tablet", strength: "10mg" },
        { id: 53, name: "Canagliflozin", form: "Tablet", strength: "100mg" },
        { id: 54, name: "Rosuvastatin", form: "Tablet", strength: "10mg" },
        { id: 55, name: "Ezetimibe", form: "Tablet", strength: "10mg" },
        { id: 56, name: "Fenofibrate", form: "Tablet", strength: "160mg" },
        { id: 57, name: "Gemfibrozil", form: "Tablet", strength: "600mg" },
        { id: 58, name: "Nitroglycerin", form: "Tablet", strength: "2.6mg" },
        { id: 59, name: "Isosorbide Mononitrate", form: "Tablet", strength: "20mg" },
        { id: 60, name: "Isosorbide Dinitrate", form: "Tablet", strength: "10mg" },
        { id: 61, name: "Folic Acid", form: "Tablet", strength: "5mg" },
        { id: 62, name: "Vitamin B12", form: "Tablet", strength: "1500mcg" },
        { id: 63, name: "Vitamin D3", form: "Tablet", strength: "60000IU" },
        { id: 64, name: "Calcium Carbonate", form: "Tablet", strength: "500mg" },
        { id: 65, name: "Ferrous Sulfate", form: "Tablet", strength: "200mg" },
        { id: 66, name: "Zinc Sulfate", form: "Tablet", strength: "20mg" },
        { id: 67, name: "Cholecalciferol", form: "Tablet", strength: "60000IU" },
        { id: 68, name: "Levocetirizine", form: "Tablet", strength: "5mg" },
        { id: 69, name: "Loratadine", form: "Tablet", strength: "10mg" },
        { id: 70, name: "Desloratadine", form: "Tablet", strength: "5mg" },
        { id: 71, name: "Fexofenadine", form: "Tablet", strength: "120mg" },
        { id: 72, name: "Ebastine", form: "Tablet", strength: "10mg" },
        { id: 73, name: "Hydroxyzine", form: "Tablet", strength: "25mg" },
        { id: 74, name: "Chlorpheniramine", form: "Tablet", strength: "4mg" },
        { id: 75, name: "Promethazine", form: "Tablet", strength: "25mg" },
        { id: 76, name: "Betamethasone", form: "Tablet", strength: "0.5mg" },
        { id: 77, name: "Dexamethasone", form: "Tablet", strength: "0.5mg" },
        { id: 78, name: "Methylprednisolone", form: "Tablet", strength: "4mg" },
        { id: 79, name: "Triamcinolone", form: "Tablet", strength: "4mg" },
        { id: 80, name: "Hydrocortisone", form: "Tablet", strength: "10mg" },
        { id: 81, name: "Prednisolone", form: "Tablet", strength: "5mg" },
        { id: 82, name: "Fluconazole", form: "Tablet", strength: "150mg" },
        { id: 83, name: "Itraconazole", form: "Capsule", strength: "100mg" },
        { id: 84, name: "Terbinafine", form: "Tablet", strength: "250mg" },
        { id: 85, name: "Clotrimazole", form: "Tablet", strength: "100mg" },
        { id: 86, name: "Albendazole", form: "Tablet", strength: "400mg" },
        { id: 87, name: "Mebendazole", form: "Tablet", strength: "100mg" },
        { id: 88, name: "Ivermectin", form: "Tablet", strength: "12mg" },
        { id: 89, name: "Praziquantel", form: "Tablet", strength: "600mg" },
        { id: 90, name: "Artemether", form: "Tablet", strength: "80mg" },
        { id: 91, name: "Lumefantrine", form: "Tablet", strength: "480mg" },
        { id: 92, name: "Chloroquine", form: "Tablet", strength: "250mg" },
        { id: 93, name: "Quinine", form: "Tablet", strength: "300mg" },
        { id: 94, name: "Oseltamivir", form: "Capsule", strength: "75mg" },
        { id: 95, name: "Acyclovir", form: "Tablet", strength: "400mg" },
        { id: 96, name: "Valacyclovir", form: "Tablet", strength: "500mg" },
        { id: 97, name: "Lamivudine", form: "Tablet", strength: "150mg" },
        { id: 98, name: "Tenofovir", form: "Tablet", strength: "300mg" },
        { id: 99, name: "Efavirenz", form: "Tablet", strength: "600mg" },
        { id: 100, name: "Nevirapine", form: "Tablet", strength: "200mg" }
];
